import { Toast } from 'bootstrap';

export default function initToast() {
  const toasts = document.querySelectorAll('[data-bs-toggle="toast"]');

  toasts.forEach((el) => {
    const target = document.querySelector(el.getAttribute('data-bs-target'));

    if (target) {
      el.addEventListener('click', () => {
        const toast = new Toast(target);

        toast.show();
      });
    }
  });
}
